@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@import '@helsenorge/designsystem-react/scss/breakpoints';

.videocard-wrapper {
  margin-bottom: spacers.$spacer;

  @media (min-width: map.get($grid-breakpoints, md)) {
    margin-bottom: spacers.getSpacer(m);
    padding-right: spacers.getSpacer(xs);
    padding-left: spacers.getSpacer(xs);
  }
}

@mixin focus-effect($box-shadow-color) {
  &:focus-within {
    box-shadow: 0 0 0 6px $box-shadow-color;
  }
}

.videocard {
  $card: &;
  $colors: 'neutral', 'blueberry', 'cherry';

  display: flex;
  flex-direction: column;
  cursor: pointer;
  height: 100%;

  $focus-effect-map: (
    'neutral': palette.$black,
    'blueberry': palette.$blueberry500,
    'cherry': palette.$cherry500,
  );

  @each $color in $colors {
    &--#{$color} {
      background-color: map.get(palette.$palette-map, #{$color}100);
      &:hover,
      &#{$card}--selected {
        background-color: map.get(palette.$palette-map, #{$color}200);
      }

      @include focus-effect(map.get($focus-effect-map, $color));
    }
  }

  @each $color, $box-shadow-color in $focus-effect-map {
    &--#{$color}#{&}--selected {
      box-shadow: 0 0 0 6px #{$box-shadow-color};
    }
  }

  &--selected {
    box-shadow: 0 0 0 6px palette.$neutral600;
  }

  &__image-wrapper {
    display: flex;
    width: 100%;
  }

  &__image {
    width: 100%;
    height: 10.125rem;
    object-fit: cover;

    @media (min-width: map.get($grid-breakpoints, md)) {
      height: 8.5rem;

      &--medium-height {
        height: 8.5rem;
      }

      &--tall-height,
      &--tall-height-tablet {
        height: 10.125rem;
      }
    }

    @media (min-width: map.get($grid-breakpoints, lg)) {
      height: 8.438rem;

      &--medium-height {
        height: 11.875rem;
      }

      &--tall-height {
        height: 17.813rem;
      }

      &--max-height {
        height: 23rem;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: spacers.getSpacer(s);
  }

  &__title {
    font-size: 1.4rem;
    margin-top: spacers.getSpacer(s);
    margin-bottom: 0;
  }

  &__description {
    margin-top: spacers.getSpacer(2xs);
    margin-bottom: 0;
  }
}

.playbutton {
  cursor: pointer;
  border: none;
  background: none;
  outline: none;
  display: flex;
  align-items: center;
  margin-left: spacers.getSpacer(s) * -1;
  padding: 0;

  // Triks for å få hele videkortet til å trigge klikk på knappen
  &::after {
    inset: 0;
    content: '';
    position: absolute;
  }

  &__label {
    font-size: 1.3rem;
    color: palette.$blueberry700;
    margin-left: spacers.getSpacer(s);

    &--active {
      color: palette.$blueberry800;
    }
  }
}
